import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShopifyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shopify"}/>
}
